import { memo, useState } from 'react'
import { EditorProps } from 'react-data-grid'
import Modal from './Modal'
import { AiOutlineClose } from 'react-icons/ai'
import { SummaryReceiptRow } from "../constants/Column"
import { OrderReceipt } from "./types"

const InputReceiptReject = memo(({ props } : {
  props: EditorProps<OrderReceipt, SummaryReceiptRow>
}) => {
  const { onClose, onRowChange, row } = props
  const [ comment, setComment ] = useState<string>(row.remark || '')
  const [ rejectQty, setRejectQty ] = useState<number>(row.reject || 0)
  
  return <Modal show={true} onHide={onClose}
    TitleIcon={AiOutlineClose}
    okTheme='danger'
    okText='ยืนยัน'
    okAction={() => {
      let updatedRow = { ...row }
      updatedRow.reject = rejectQty
      updatedRow.remark = comment
      onRowChange(updatedRow, true)
    }}
    cancelText='ปิด'
    title='บันทึก Reject ของ FG'
    maxWidth='max-w-lg'
    okDisable={rejectQty < 0 || comment === ''}
    >
    <div className="w-full space-y-3 ">
      <div className="space-y-1">
        <p className="font-bold ">จำนวน</p>
        <input 
          className='input-form-text'
          type="number"
          inputMode="numeric"
          placeholder='กรอกยอด REJECT'
          autoFocus={true}
          enterKeyHint='done'
          value={rejectQty}
          onChange={(e) => setRejectQty(Number(e.currentTarget.value))}
        />
      </div> 
      <div className="space-y-1">
        <p className="font-bold ">เหตุผล</p>
        <textarea 
          className={`input-form-text`}
          placeholder="กรุณากรอกเหตุผลการไม่อนุมัติ" 
          value={comment} onChange={(e) => setComment(e.currentTarget.value)}
          >
        </textarea>
      </div>
    </div>
  </Modal>
})

export default InputReceiptReject